import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../components/Loader'
import OrgFriendAccept from "../../components/OrgFriendAccept"


//people who have requested to join an organization as friends

const FriendshipRequests = () => {
    const { organization } = useParams()

    const [friendRequests, setFriendRequests] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [page, setPage] = useState(1)
    const [acceptFriends, setAcceptFriends] = useState(false)

    useEffect(() => {
        const getRequests = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/friends/join`, { params: { page } })
                if (response) {
                    setIsLoading(false)
                    setFriendRequests(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                setErrorMsg(error.data.message)
            }
        }

        getRequests()
    }, [])

    const refresh = async () => { }

    const acceptAll = async () => {
        try {
            setAcceptFriends(true)
            const response = api.patch(`/${organization}/manage/friends`)
            if (response) {
                setAcceptFriends(false)
                toast.success(response.data.message)
            }
        } catch (error) {
            setAcceptFriends(false)
            toast.error(error.response.data.message)
        }
    }

    return (
        <div>
            <h3 className="page-header-title">{organization}</h3><span>Friend Requests</span>
            <button className='action-btn' onClick={acceptAll}>{acceptFriends?<Loader/>:"Accept All"}</button>
            <div className="user-list">
                <InfiniteScroll
                    dataLength={friendRequests.length}
                    pullDownToRefresh={true}
                    loader={<Loader />}
                    refreshFunction={refresh}
                >
                    {isLoading && <Loader />}
                    {!isLoading && friendRequests.length === 0 &&
                        <p className="not-found-msg">No friend requests found</p>
                    }
                    {
                        friendRequests.length > 0 && friendRequests.map((request) => (
                            <OrgFriendAccept key={request._id} user={request} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default FriendshipRequests